import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_hearings = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_HEARINGS}/`);
};
export const dispute_resolution_getbyid_hearings = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_HEARINGS}/by-id/${id}`);
};
export const dispute_resolution_add_hearings = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_HEARINGS}/`, data);
};
export const dispute_resolution_update_hearings = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_HEARINGS}/${id}`, data);
};
export const dispute_resolution_delete_hearings = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_HEARINGS}/${id}`);
};
